import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { Mark } from "./Mark";
import { CONTACT_EMAIL } from "../data/content";

export const Footer = () => {
  return (
  <footer data-testid="footer-section" className="grain relative bg-obsidian pt-24 pb-10">
    <div className="relative mx-auto max-w-[1500px] px-6 lg:px-12">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <Link to="/" className="shrink-0" data-testid="footer-logo-link">
              <Mark className="h-16 w-16" onDark />
            </Link>
            <div>
              <p className="font-display text-xl tracking-[0.1em] text-sand">THREE ABIDE</p>
              <p className="label-eyebrow text-sage">Ministries</p>
            </div>
          </div>
          <p className="font-display mt-9 max-w-md text-2xl italic leading-snug text-sand/85">
            “And now these three remain: faith, hope and love.”
          </p>
          <p className="label-eyebrow mt-4 text-gold">1 Corinthians 13:13</p>
        </div>

        <div className="lg:col-span-4 lg:col-start-9">
          <p className="label-eyebrow text-sand/40">Contact</p>
          <div className="mt-6 space-y-4 text-sm">
            <p className="font-display text-xl text-sand">Todd Boyle</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email-link"
              className="link-wipe block text-sand/75 transition-colors hover:text-sand"
            >
              {CONTACT_EMAIL}
            </a>
            <a
              href="tel:+14793671092"
              data-testid="footer-phone-link"
              className="link-wipe block text-sand/75 transition-colors hover:text-sand"
            >
              (479) 367-1092
            </a>
          </div>
        </div>
      </div>

      <div className="mt-20 flex flex-col items-start justify-between gap-5 border-t border-sand/12 pt-7 sm:flex-row sm:items-center">
        <p className="font-mono-accent text-[0.64rem] uppercase tracking-[0.18em] text-sand/35">
          © {new Date().getFullYear()} Three Abide Ministries · Faith · Hope · Love
        </p>
        <button
          type="button"
          onClick={() =>
            window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.4 }) : window.scrollTo(0, 0)
          }
          data-testid="footer-scroll-top-btn"
          className="btn-sheen inline-flex items-center gap-2 rounded-full border border-sand/25 px-5 py-2.5 font-mono-accent text-[0.64rem] uppercase tracking-[0.18em] text-sand/70 hover:bg-sand hover:text-obsidian"
        >
          <ArrowUp size={13} /> Back to top
        </button>
      </div>
    </div>
  </footer>
  );
};
